const localization = {
  nl: {
    actionBook: 'Boek via Micazu',
  },
  de: {
    actionBook: 'Buchen mit Micazu',
  },
  en: {
    actionBook: 'Book through Micazu',
  },
}

export default localization



// WEBPACK FOOTER //
// ./src/components/Navigation/localization.js